import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

function RegisterPage() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    first: "",
    last: "",
  });
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await register(form);
      nav("/");
    } catch (ex) {
      setErr(ex.message);
    }
  };
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Create account</h1>
      <form
        className="jh-form-grid"
        onSubmit={submit}
        style={{ maxWidth: 480, margin: "0 auto" }}
      >
        {err && (
          <div className="jh-note" style={{ color: "#b91c1c" }}>
            {err}
          </div>
        )}
        <div className="jh-two">
          <div className="jh-field">
            <label className="jh-label">First</label>
            <input
              className="jh-input wide"
              value={form.first}
              onChange={(e) => setForm((f) => ({ ...f, first: e.target.value }))}
            />
          </div>
          <div className="jh-field">
            <label className="jh-label">Last</label>
            <input
              className="jh-input wide"
              value={form.last}
              onChange={(e) => setForm((f) => ({ ...f, last: e.target.value }))}
            />
          </div>
        </div>
        <div className="jh-field">
          <label className="jh-label">Username</label>
          <input
            className="jh-input wide"
            value={form.username}
            onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))}
          />
        </div>
        <div className="jh-field">
          <label className="jh-label">Email</label>
          <input
            className="jh-input wide"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          />
        </div>
        <div className="jh-field">
          <label className="jh-label">Password</label>
          <input
            type="password"
            className="jh-input wide"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          />
        </div>
        <div className="jh-actions">
          <button className="jh-btn" type="submit">
            Create account
          </button>
        </div>
        <div className="jh-note">
          Already have an account? <Link to="/login">Sign in</Link>
        </div>
      </form>
    </section>
  );
}

export default RegisterPage;
